import { useState, useCallback } from 'react';
import { EmailMailbox } from '../types';
import { emailApi } from '../services/communicationsApi';
import { apiErrorMessage } from '../utils/emailChannel';

export const useEmailMailboxes = () => {
  const [mailboxes, setMailboxes] = useState<EmailMailbox[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMailboxes = useCallback(async (channelId: number) => {
    setLoading(true);
    setError(null);
    try {
      const data = await emailApi.getMailboxes(channelId);
      setMailboxes(data);
      return data;
    } catch (err) {
      const msg = apiErrorMessage(err, 'Failed to load folders');
      setError(msg);
      setMailboxes([]);
      const wrapped = new Error(msg);
      throw wrapped;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearMailboxes = useCallback(() => {
    setMailboxes([]);
    setError(null);
  }, []);

  return { mailboxes, loading, error, fetchMailboxes, clearMailboxes };
};
